import { Flex } from 'components';
import useOffers from 'features/offers/useOffers';
import { useSchool } from 'features/school';
import moment from 'moment';
import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

const CopyStyle = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.gray_500};

  a {
    color: ${({ theme }) => theme.colors.gray_500};
    text-decoration: underline;
    outline: none;

    &:hover {
      color: ${({ theme }) => theme.colors.dark_350};
    }
  }
`;

interface CopyProps {
  freeOffer: boolean;
}

const Copy = ({ freeOffer }: CopyProps) => {
  const { offerIdentifier } = useParams();

  const { buyInformation } = useOffers();
  const { schoolUuid, schoolMelver } = useSchool();

  const schoolAndre = schoolUuid === '85338cb1-8075-4dcf-afe2-6ce534dcde27';
  // const schoolG10 = schoolUuid === '14d970bd-3794-4268-bf67-2c5d2d0f0285';
  const schoolTSE = schoolUuid === '76cebc79-bf6c-4144-bab2-947362f3f8c4';
  // const schoolMeuPlanoCrypto = schoolUuid === '20b929ad-c773-46e2-93de-991988587835';
  const school3xperiencia = schoolUuid === 'fe8e4d2e-30cd-41d8-8e32-ad3bcd79ad9a';

  const YEAR = moment().format('YYYY');

  return (
    <Flex mt={3}>
      {/* André */}
      {schoolAndre && (
        <CopyStyle>
          {!freeOffer && (
            <>
              * Parcelamento com tarifa aproximada de 1,7% ao mês.
              <br />O pagamento estará disponível em sua fatura como {buyInformation?.creditCardInformation}.
              <br />
              Ao realizar o pagamento você concorda com os termos de uso e política de privacidade.
              <br />
              <br />
            </>
          )}
          © TRADER AO VIVO {YEAR} - Todos os direitos reservados
          <br />
          CNPJ: 44.540.746/0001-63
        </CopyStyle>
      )}

      {/* Outros */}
      {!schoolAndre && (
        <CopyStyle>
          {!freeOffer && (
            <>
              * Parcelamento com tarifa aproximada de 1,7% ao mês.
              <br />O pagamento estará disponível em sua fatura como {buyInformation?.creditCardInformation}.
              <br />
              <br />
            </>
          )}

          {schoolMelver && (
            <>
              {!freeOffer && (
                <>
                  Ao realizar o pagamento você concorda com os{' '}
                  <a href="https://www.melver.com.br/termos-e-politicas/" target="_blank" rel="noreferrer">
                    termos de uso e política de privacidade
                  </a>
                  .
                  <br />
                  <br />
                </>
              )}
              © MELVER SA {YEAR} - Todos os direitos reservados
              <br />
              CNPJ: 40.919.092/0001-22
            </>
          )}

          {schoolTSE && (
            <>
              © Editora Termine Seu Estudo LTDA {YEAR} - Todos os direitos reservados
              <br />
              CNPJ: 34.046.427/0001-42
            </>
          )}

          {school3xperiencia && (
            <>
              Ao realizar o pagamento você concorda com o{' '}
              {offerIdentifier === 'OvHygEpNkL' ? (
                <a href="/downloads/3xperiencia/termo-de-adesao-que-foto.pdf" target="_blank" rel="noreferrer">
                  termo de adesão
                </a>
              ) : (
                <a href="/downloads/3xperiencia/termo-de-adesao.pdf" target="_blank" rel="noreferrer">
                  termo de adesão
                </a>
              )}
              .
              <br />
              <br />© 3XPERIÊNCIA {YEAR} - Todos os direitos reservados
              <br />
              CNPJ: 45.808.505/0001-83
            </>
          )}
        </CopyStyle>
      )}
    </Flex>
  );
};

export default Copy;
